<div class="gas-plant-mapping-wrapper">
  <div class="table-title">Admin</div>

  <div class="table-wrapper">
    <div class="table-card" [class.expanded]="expandedTable === 'admin'">
      <div class="table-header">
        <h3>Oil and Gas Mapping</h3>
        <div class="button-group">
          <button class="expand-btn" (click)="toggleExpand('admin')">
            {{ expandedTable === "admin" ? "Collapse" : "Open" }}
          </button>
          <button (click)="addRow()">New</button>
          <button (click)="handleSave()">Save</button>
          <button (click)="handleDelete()" [disabled]="!selectedRows.length">
            Delete
          </button>
          <button (click)="cancelAdminChanges()">Cancel</button>
          <button (click)="clearAllAdminFilters()" [disabled]="!hasAdminFiltersApplied()">
            Clear Filter
          </button>
          <button (click)="openAdminExportDialog()">Export</button>
        </div>
      </div>
      <div
        class="table-scroll"
        [ngClass]="{ 'scroll-expanded': expandedTable === 'admin' }"
      >
        <table>
          <thead>
            <tr>
              <th>Select</th>
              <th>
                Dev Area
                <img
                  *ngIf="expandedTable === 'admin'"
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isAdminFilterActive('devArea') }"
                  [src]="isAdminFilterActive('devArea') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'devArea')"
                  [title]="isAdminFilterActive('devArea') ? 'Filter applied - Dev Area' : 'Filter Dev Area'"
                />
              </th>
              <th>
                Facility Type
                <img
                  *ngIf="expandedTable === 'admin'"
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isAdminFilterActive('facilityType') }"
                  [src]="isAdminFilterActive('facilityType') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'facilityType')"
                  [title]="isAdminFilterActive('facilityType') ? 'Filter applied - Facility Type' : 'Filter Facility Type'"
                />
              </th>
              <th>
                Facility Name
                <img
                  *ngIf="expandedTable === 'admin'"
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isAdminFilterActive('facilityName') }"
                  [src]="isAdminFilterActive('facilityName') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'facilityName')"
                  [title]="isAdminFilterActive('facilityName') ? 'Filter applied - Facility Name' : 'Filter Facility Name'"
                />
              </th>
              <th>
                Oil Take Away
                <img
                  *ngIf="expandedTable === 'admin'"
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isAdminFilterActive('oilTakeAway') }"
                  [src]="isAdminFilterActive('oilTakeAway') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'oilTakeAway')"
                  [title]="isAdminFilterActive('oilTakeAway') ? 'Filter applied - Oil Take Away' : 'Filter Oil Take Away'"
                />
              </th>
              <th>
                Gas Take Away
                <img
                  *ngIf="expandedTable === 'admin'"
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isAdminFilterActive('gasTakeAway') }"
                  [src]="isAdminFilterActive('gasTakeAway') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'gasTakeAway')"
                  [title]="isAdminFilterActive('gasTakeAway') ? 'Filter applied - Gas Take Away' : 'Filter Gas Take Away'"
                />
              </th>
              <th>
                Priority
                <img
                  *ngIf="expandedTable === 'admin'"
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isAdminFilterActive('priority') }"
                  [src]="isAdminFilterActive('priority') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openFloatingFilter($event, 'priority')"
                  [title]="isAdminFilterActive('priority') ? 'Filter applied - Priority' : 'Filter Priority'"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data">
              <td>
                <input
                  type="checkbox"
                  [checked]="selectedRows.includes(row)"
                  (change)="toggleRowSelection(row, $event)"
                />
              </td>
              <td>
  <div *ngIf="row.isNew; else devAreaText">
    <select [(ngModel)]="row.devArea" (change)="onDropdownChange(row)">
      <option value="">-- Select --</option>
      <optgroup label="Development Areas" class="dev-area-group">
        <option *ngFor="let option of devAreaOptions" [value]="option">
          {{ option }}
        </option>
      </optgroup>
      <optgroup label="Sub Development Areas" class="sub-dev-area-group">
        <option *ngFor="let option of subDevAreaOptions" [value]="option">
          {{ option }}
        </option>
      </optgroup>
    </select>
  </div>
  <ng-template #devAreaText>{{ row.devArea }}</ng-template>
</td>
              <td>
                <div *ngIf="row.isNew; else facilityTypeText">
                  <select [(ngModel)]="row.facilityType" (change)="onDropdownChange(row)">
                    <option value="">-- Select --</option>
                    <option
                      *ngFor="let option of facilityTypeOptions"
                      [value]="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
                <ng-template #facilityTypeText>{{
                  row.facilityType
                }}</ng-template>
              </td>
              <td>
                <div *ngIf="row.isNew; else facilityNameInput">
                  <select
                    [(ngModel)]="row.facilityName"
                    (change)="handleFacilityNameChange($event, row)"
                    [disabled]="!isFacilityNameEditable(row)"
                  >
                    <option value="">-- Select --</option>
                    <option
                      *ngIf="canAddNewFacility(row)"
                      value="add-new"
                      style="color: red; font-weight: bold"
                    >
                      Add New Facility
                    </option>
                    <option
                      *ngFor="let option of facilityNameOptions"
                      [value]="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
                <ng-template #facilityNameInput>
                  <input
                    type="text"
                    [(ngModel)]="row.facilityName"
                    placeholder="Enter Facility Name"
                    [disabled]="!isFacilityNameEditable(row)"
                  />
                </ng-template>
              </td>
              <td>
                <div *ngIf="row.isNew; else oilTakeAwayText">
                  <select
                    [(ngModel)]="row.oilTakeAway"
                    (change)="handleOilTakeAwayChange($event, row)"
                    [disabled]="shouldDisableOilTakeAway(row)"
                    [class.no-arrow]="shouldDisableOilTakeAway(row)"
                  >
                    <option value="">-- Select --</option>
                    <option
                      value="add-new"
                      style="color: red; font-weight: bold"
                    >
                      Add New Oil Take Away
                    </option>
                    <option
                      *ngFor="let option of oilTakeAwayOptions"
                      [value]="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
                <ng-template #oilTakeAwayText>{{ row.oilTakeAway }}</ng-template>
              </td>
              <td>
                <div *ngIf="row.isNew; else gasTakeAwayText">
                  <select
                    [(ngModel)]="row.gasTakeAway"
                    (change)="handleGasTakeAwayChange($event, row)"
                    [disabled]="shouldDisableGasTakeAway(row)"
                    [class.no-arrow]="shouldDisableGasTakeAway(row)"
                  >
                    <option value="">-- Select --</option>
                    <option
                      value="add-new"
                      style="color: red; font-weight: bold"
                    >
                      Add New Gas Takeaway
                    </option>
                    <option
                      *ngFor="let option of gasTakeAwayOptions"
                      [value]="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
                <ng-template #gasTakeAwayText>{{ row.gasTakeAway }}</ng-template>
              </td>
              <td>
                <div *ngIf="row.isNew; else priorityDropdown">
                  <select
                    [(ngModel)]="row.priority"
                    [disabled]="row.facilityType === 'CDP'"
                    [class.no-arrow]="row.facilityType === 'CDP'"
                  >
                    <option value="">-- Select --</option>
                    <option *ngIf="row.priority === 0 || row.priority === '0'" [value]="0" hidden>
                      0
                    </option>
                    <option
                      *ngFor="let option of editablePriorityOptions"
                      [value]="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
                <ng-template #priorityDropdown>
                  <select
                    [(ngModel)]="row.priority"
                    [disabled]="row.facilityType === 'CDP'"
                    [class.no-arrow]="row.facilityType === 'CDP'"
                  >
                    <option value="">-- Select --</option>
                    <option *ngIf="row.priority === 0 || row.priority === '0'" [value]="0" hidden>
                      0
                    </option>
                    <option
                      *ngFor="let option of editablePriorityOptions"
                      [value]="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <br />
  <br />

  <br />
  <div class="table-wrapper">
    <div class="table-card" [class.expanded]="expandedTable === 'subDevArea'">
      <div class="table-header">
        <h3>Sub Dev Area Mapping</h3>
        <div class="button-group">
          <button class="expand-btn" (click)="toggleExpand('subDevArea')">
            {{ expandedTable === "subDevArea" ? "Collapse" : "Open" }}
          </button>
          <button (click)="addNewSubDevAreaRow()">New</button>
          <button (click)="handleSubDevSave()">Save</button>
          <button (click)="handleSubDevDelete()" [disabled]="!selectedRows.length">
            Delete
          </button>
          <button (click)="cancelSubDevChanges()">Cancel</button>
          <button (click)="clearAllSubDevFilters()" [disabled]="!hasSubDevFiltersApplied()">
            Clear Filter
          </button>
          <button (click)="openSubDevExportDialog()">Export</button>
        </div>
      </div>
      <div
        class="table-scroll"
        [ngClass]="{ 'scroll-expanded': expandedTable === 'subDevArea' }"
      >
        <table>
          <thead>
            <tr>
              <th>Select</th>
              <th>
                Dev Area
                <img
                  *ngIf="expandedTable === 'subDevArea'"
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isSubDevFilterActive('devArea') }"
                  [src]="isSubDevFilterActive('devArea') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openSubDevFloatingFilter($event, 'devArea')"
                  [title]="isSubDevFilterActive('devArea') ? 'Filter applied - Dev Area' : 'Filter Dev Area'"
                />
              </th>
              <th>
                Sub Dev Area
                <img
                  *ngIf="expandedTable === 'subDevArea'"
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isSubDevFilterActive('subDevArea') }"
                  [src]="isSubDevFilterActive('subDevArea') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openSubDevFloatingFilter($event, 'subDevArea')"
                  [title]="isSubDevFilterActive('subDevArea') ? 'Filter applied - Sub Dev Area' : 'Filter Sub Dev Area'"
                />
              </th>
              <th>
                Pad Name
                <img
                  *ngIf="expandedTable === 'subDevArea'"
                  class="filter-icon"
                  [ngClass]="{ 'active-filter': isSubDevFilterActive('padName') }"
                  [src]="isSubDevFilterActive('padName') ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                  width="16"
                  height="16"
                  alt="Filter"
                  (click)="openSubDevFloatingFilter($event, 'padName')"
                  [title]="isSubDevFilterActive('padName') ? 'Filter applied - Pad Name' : 'Filter Pad Name'"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of dataSubDevArea">
              <td>
                <input
                  type="checkbox"
                  [checked]="selectedRows.includes(row)"
                  (change)="toggleRowSelection(row, $event)"
                />
              </td>
              <td>
                <div *ngIf="row.isNew; else devAreaText">
                  <select
                    [(ngModel)]="row.devArea"
                    (change)="onSubDevRowDevAreaChange(row)"
                  >
                    <option value="">-- Select --</option>
                    <option
                      *ngFor="let option of devAreaOptions"
                      [value]="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
                <ng-template #devAreaText>{{ row.devArea }}</ng-template>
              </td>
              <td>
                <input
                  type="text"
                  [(ngModel)]="row.subDevArea"
                  (input)="handleSubDevEdit(row)"
                  placeholder="Enter Sub Dev Area"
                />
              </td>
              <td>
                <div class="multi-owner-field">
                  <div class="owner-tags">
                    <div *ngFor="let pad of row.padName" class="owner-chip">
                      {{ pad }}
                      <span class="remove-chip" (click)="removePad(row, pad); handleSubDevEdit(row)">
                        &times;
                      </span>
                    </div>
                  </div>

                  <div class="pad-search-wrapper">
                    <input
                      #inlinePadSearch
                      type="text"
                      [(ngModel)]="padSearch[row._rowId]"
                      placeholder="Search pads..."
                      (focus)="openPadDropdown(row, $event, inlinePadSearch)"
                      (input)="openPadDropdown(row, $event, inlinePadSearch)"
                      (keydown.enter)="handlePadInputEnter($event, row)"
                    />

                    <div
                      class="pad-dropdown-panel"
                      *ngIf="activePadDropdownRowId === row._rowId"
                      [ngStyle]="{
                        top: padDropdownPosition.top + 'px',
                        left: padDropdownPosition.left + 'px'
                      }"
                    >
                      <div class="pad-dropdown-list">
                        <div
                          *ngFor="let opt of getFilteredPadOptions(row)"
                          class="pad-dropdown-item"
                          [class.selected-option]="row.padName && row.padName.includes(opt)"
                          (click)="row.padName && row.padName.includes(opt) ? null : confirmAddPad(row, opt)"
                          [attr.aria-disabled]="row.padName && row.padName.includes(opt) ? 'true' : null"
                        >
                          {{ opt }}
                        </div>
                        <div
                          *ngIf="getFilteredPadOptions(row).length === 0"
                          class="no-options"
                        >
                          No pads found
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Filter Box -->
  <div
    class="floating-filter-dropdown"
    *ngIf="showFloatingFilter"
    [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }"
  >
    <input
      type="text"
      [(ngModel)]="filterSearch[activeFilter]"
      placeholder="Search..."
    />

    <div *ngIf="isLoadingFilterOptions || isLoadingSubDevFilterOptions" class="filter-loading">
      <div class="spinner-small"></div>
      Loading options...
    </div>

    <div *ngIf="!isLoadingFilterOptions && !isLoadingSubDevFilterOptions" class="filter-options">
      <div
        *ngIf="getFilterOptions(activeFilter).length === 0"
        class="no-options"
      >
        No options available based on current filters
      </div>
      <div
        class="filter-options-count"
        *ngIf="getFilterOptions(activeFilter).length > 0"
      >
        {{ getFilterOptions(activeFilter).length }} options available
      </div>
      <label *ngFor="let option of getFilterOptions(activeFilter)">
        <input
          type="checkbox"
          [checked]="isChecked(activeFilter, option)"
          (change)="toggleMultiFilter(activeFilter, option, $event)"
        />
        <span>{{ getFilterOptionLabel(option) }}</span>
      </label>
    </div>

    <div class="filter-buttons">
      <button (click)="applyFilterClick()">Apply</button>
      <button (click)="clearFilterClick()">Clear</button>
    </div>
  </div>

  <!-- Delete Confirmation Dialog -->
  <ng-template #deleteConfirmDialog>
    <div class="dialog-container">
      <h2 class="dialog-title">Confirm Delete</h2>
      <div class="dialog-content">
        <p>{{ dialogMessage }}</p>
      </div>
      <div class="dialog-actions">
        <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
        <button class="delete-button" [mat-dialog-close]="true">Delete</button>
      </div>
    </div>
  </ng-template>

  <ng-template #adminExportOptionsDialog>
    <div class="dialog-container export-dialog-container">
      <h2 class="dialog-title">Export Oil and Gas Mapping</h2>
      <div class="dialog-content export-dialog-content">
        <p>Select which data you want to download.</p>
      </div>
      <div class="export-dialog-actions">
        <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportCSV()">Export Filtered</button>
        <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllAdminData()">Export All</button>
      </div>
      <div class="dialog-actions export-dialog-footer">
        <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      </div>
    </div>
  </ng-template>

  <ng-template #subDevExportOptionsDialog>
    <div class="dialog-container export-dialog-container">
      <h2 class="dialog-title">Export Oil and Gas Sub Dev Area</h2>
      <div class="dialog-content export-dialog-content">
        <p>Select which data you want to download.</p>
      </div>
      <div class="export-dialog-actions">
        <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportSubDevCSV()">Export Filtered</button>
        <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllSubDevAreaData()">Export All</button>
      </div>
      <div class="dialog-actions export-dialog-footer">
        <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      </div>
    </div>
  </ng-template>
  
  <!-- Add Option Modal (template-driven) -->
  <div class="modal-overlay" *ngIf="showAddOptionModal">
    <div class="modal-content">
      <h3>Add New {{ addOptionLabel }}</h3>
      <div class="modal-field">
        <label>{{ addOptionLabel }}</label>
        <input type="text" [(ngModel)]="newOptionValue" placeholder="Enter new value" />
      </div>
      <div class="modal-buttons">
        <button (click)="confirmAddOption()">Save</button>
        <button class="cancel-button" (click)="closeAddOptionPopup()">Cancel</button>
      </div>
    </div>
  </div>
</div>
